import { atom } from 'jotai';
import { ColorPalette } from '@shared/schemas/colorPalette'; // Adjust path as needed

export interface ColorPaletteWithComputedFields extends ColorPalette {
  // defaultColor will be part of ColorPalette schema after schema update
  // isGradient will be part of ColorPalette schema after schema update
  computedDefaultColor: string; // The color to apply by default
}

// Atom to store all available palettes (default + custom)
export const allPalettesAtom = atom<ColorPaletteWithComputedFields[]>([]);

// Atom to store only custom palettes for management purposes
export const customPalettesAtom = atom<ColorPaletteWithComputedFields[]>([]);

// Atom for managing the currently selected palette in a picker or setting
export const selectedPaletteIdAtom = atom<string | null>(null);

// TODO: Add derived atoms or atomsWithQuery for fetching/updating palettes
// e.g., an atom to fetch palettes from Firestore via a Firebase function

// Helper function to determine the default color
export const calculateDefaultColor = (palette: ColorPalette): string => {
  if (palette.defaultColor) {
    return palette.defaultColor; // User-defined default takes precedence
  }
  if (palette.isGradient && palette.colors.length > 0) {
    const middleIndex = Math.floor(palette.colors.length / 2);
    return palette.colors[middleIndex];
  }
  if (palette.colors.length > 0) {
    return palette.colors[0];
  }
  return '#000000'; // Fallback color
}; 